module.exports = __webpack_public_path__ + "img/TSGLadestationNotAus.a006106b.png";